<template>
    <div class="fluid page_content" v-if="permission && permission.version === '5'">

      <div class="page_heading">
        <div class="col-5 module_heading" role="heading" aria-level="1">
          <span class="program_guide_icon icon-list"></span>
          <span class="program_guide_title">Institution Management</span>
        </div>

        <div class="col-7 btn_container">
          <button class="btn btn-primary" aria-label="upload" :disabled="!createInsitutionButtonEnabled" @click="createInstitutionClicked">new</button>
        </div>
      </div>

		<div class="user-management-section">
      <div class="page_subheading">
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <button type="button" :disabled="this.firstPage" @click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
            <button type="button" :disabled="this.lastPage" @click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
          <div class="search-box-container">
            <input type="text" class="input-search" v-model="searchTitle" placeholder="search by name" aria-label="search by name" @keyup.enter="search">
            <button type="button" class="btn btn_srh" @click="search" aria-label="search institutions">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
          </div>
        </div>
      </div>

			<div class="table_containers">
				<table v-if="isInstitutionsLoaded" class="table user-management-table">
					<thead class="thead-light">
						<tr>
							<td class="first-column">Institution Name</td>
							<td class="second-column">Open Id</td>
							<td class="action-column">Action</td>
						</tr>
					</thead>
					<tbody v-if="institutions.length > 0">
						<tr v-for="institution in institutions">
							<td class="first-column"> <a href="#" @click.stop.prevent="goToInstitutionDetail(institution)">{{ institution.title }} {{ aka(institution) }}</a></td>
              <td class="second-column">{{ institution.openId }}</td>
							<td class="action-column">
                <template>
                  <btn class="ic_btn ic2_pencil" aria-label="edit" tabindex="0" @click="editInstitution(institution)"></btn>
                  <btn class="ic_btn icon-bin" aria-label="delete" tabindex="0" @click="showDeleteFolderConfirmBox(institution)"></btn>
                </template>
							</td>
						</tr>
					</tbody>
					<tbody v-else class="no-result">
						<tr>No Results Found</tr>
					</tbody>
				</table>
			</div>
		</div>

        <div>
            <b-modal class="delete-folder-popup" ref="institutionModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                <div>
                    <span>{{ institutionDeleteMessage }}</span>
                </div>
              <div slot="modal-header" class="popover-header">
                <div class="popup-heading">Please Confirm!</div>
                <button class="btn_close" aria-label="close" @click="hideDeleteConfirmBox">
                   <span class="ic-close"></span>
                </button>
              </div>
              <div slot="modal-footer" class="w-100">
                  <b-button @click="deleteInstitutionAndHideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
                  <b-button @click="hideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
              </div>
            </b-modal>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
import '../../../assets/module/css/user/userList.min.css'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'institution-list',
  data () {
    return {
      pageSize: 10,
      sizeOptions: [ 10, 50, 100 ],
      firstPage: true,
      lastPage: true,
      page: 0,
      totalPages: 0,
      totalElements: 0,
      institutions: [],
      isInstitutionsLoaded: false,
      institutionDeleteMessage: '',
      institutionToBeDeleted: {},
      searchTitle: ''
    }
  },

  mounted () {
    this.loadPermission().then(res => {
      this.$refs.loadingModal.show()
      setTimeout(() => {
        this.loadInstitutionList()
      }, 500)
    })
  },
  methods: {
    ...mapActions([
      'searchInstitutions',
      'deleteInstitution',
      'loadPermission'
    ]),
    loadInstitutionList () {
      this.searchInstitutions({page: this.page, count: this.pageSize, title: this.searchTitle}).then(result => {
        this.institutions = result.content
        this.page = result.number
        // latest Spring library changed Page.java fields from firstPage -> first and lastPage -> last
        this.firstPage = (result.first || result.firstPage) ? (result.first || result.firstPage) : false
        this.lastPage = (result.last || result.lastPage) ? (result.last || result.lastPage) : false
        this.totalPages = result.totalPages
        this.totalElements = result.totalElements
        this.isInstitutionsLoaded = true
        this.$refs.loadingModal.hide()
      })
    },
    showDeleteFolderConfirmBox (institution) {
      this.institutionToBeDeleted = institution
      this.$refs.institutionModal.show()
      this.institutionDeleteMessage = 'Are you sure you would like to delete this institution?'
    },
    deleteInstitutionAndHideDeleteConfirmBox () {
      this.$refs.institutionModal.hide()
      this.deleteInstitutionClicked()
    },
    deleteInstitutionClicked () {
      if (this.institutionToBeDeleted && this.institutionToBeDeleted.uuid) {
        this.deleteInstitution(this.institutionToBeDeleted.uuid).then(res => {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully deleted \'' + this.institutionToBeDeleted.title + '\''
          })
          this.loadInstitutionList()
        })
      }
    },
    hideDeleteConfirmBox () {
      this.institutionToBeDeleted = {}
      this.$refs.institutionModal.hide()
    },
    createInstitutionClicked () {
      return this.$router.push({ name: 'createInstitution' })
    },
    goToInstitutionDetail (institution) {
      return this.$router.push({ name: 'institutionDetails', params: { uuid: institution.uuid } })
    },
    editInstitution (institution) {
      return this.$router.push({ name: 'editInstitutionDetails', params: { uuid: institution.uuid } })
    },
    resetPage () {
      this.page = 0
      this.loadInstitutionList()
    },
    prev () {
      this.page = this.page - 1
      this.loadInstitutionList()
    },
    next () {
      this.page = this.page + 1
      this.loadInstitutionList()
    },
    aka (ins) {
      return ins.title!==ins.displayName?'(aka '+ins.displayName+')':''
    }, 
    search () {
      this.page = 0
      this.firstPage = true
      this.lastPage = true
      this.totalPages = 0
      this.totalElements = 0
      this.loadInstitutionList()
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission
    }),

    createInsitutionButtonEnabled () {
      let permission = this.permission
      let institutionPermission = permission.institutionPermission
      return institutionPermission && institutionPermission.create
    }
  }
}
</script>

<style scoped>
.program_guide_icon {
  float:left;
  width:30px;
  font-size:30px;
  color:#34b2ff;
  margin:3px 3px 0 0 !important;
}

.program_guide_title {
  color: #34b2ff;
  font-size: 22px;
  font-weight: 400;
  float: left;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionList.vue